ACC.productDetail = {
  _autoload: ['initPageEvents', 'bindVariantOptions'],

  checkQtySelector: function(self, mode) {
    var input = $('#qtydd_md');
    var inputVal = '';
    if (input.length > 0) inputVal = input.val();
    ACC.productDetail.updateQtyValue(self, inputVal);
  },

  updateQtyValue: function(self, value) {
    var addtocartQty = $(document)
      .find('.add_to_cart_form')
      .find('.js-qty-selector-input');
    addtocartQty.val(value);
  },

  initPageEvents: function() {
    $(document).on('change', '.js-qty-selector-input', function() {
      ACC.productDetail.checkQtySelector(this, 'minus');
    });
    $(document).on('click', '.js-add-to-cart', function() {
      ACC.productDetail.checkQtySelector(this, 'minus');
    });

    function changeOnVariantOptionSelection(optionSelected) {
      window.location.href = optionSelected.attr('value');
    }
  },

  bindVariantOptions: function() {
    ACC.productDetail.bindCurrentStyle();
    ACC.productDetail.bindCurrentSize();
    ACC.productDetail.bindCurrentType();
  },

  bindCurrentStyle: function() {
    var currentStyle = $('#currentStyleValue').data('styleValue');
    var styleSpan = $('.styleName');
    if (currentStyle != null) {
      styleSpan.text(': ' + currentStyle);
    }
  },

  bindCurrentSize: function() {
    var currentSize = $('#currentSizeValue').data('sizeValue');
    var sizeSpan = $('.sizeName');
    if (currentSize != null) {
      sizeSpan.text(': ' + currentSize);
    }
  },

  bindCurrentType: function() {
    var currentSize = $('#currentTypeValue').data('typeValue');
    var sizeSpan = $('.typeName');
    if (currentSize != null) {
      sizeSpan.text(': ' + currentSize);
    }
  }
};
